import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items }) {
  return (
    <div className="py-10 border-y border-white/10 bg-[#1C1913]">
      <Marquee speed={22} gradient={false} pauseOnHover={false}>
        {items.map((it, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10">
            <span className="editorial-marquee text-5xl md:text-7xl text-[#F2E7D0]">{it}</span>
            <span className="text-[#D97645] font-mono-label">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
